module.exports = __webpack_public_path__ + "static/media/carolin-thuemmler.6316fb2d.jpg";